import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class Vguider extends Vue {
  @Prop({ default: () => {} })
    value: DisplayVGuiderData;

  @Prop({ default: 1 })
    themeCode: number;

  // 区块背景色
  get blockBackground() {
    return this.themeCode > 3 ? '#181818' : '#ffffff';
  }

  // 分割线颜色
  get borderColor() {
    return this.themeCode > 3 ? '#333333' : '#f2f2f2';
  }

  render(h) {
    return <img class="vGuider-img" src={`${this.value.desc.enterPic}?imageView2/1/w/750/h/300`} />;
    // return !this.value.desc.isPre ? (
    //   <div class="v-guider box-shadow" style={`background: ${this.blockBackground}`}>
    //     <div class="sale-point" style={`border-bottom: 1px solid ${this.borderColor};`}>
    //       <div class="sale-point-txt">我的销售扣点</div>
    //       <div class="view-all">查看全部</div>
    //     </div>
    //     <div class="balance">
    //       <div class="balance-title">
    //         余额
    //         <span class="money">
    //           <span>￥</span>
    //           <span style="font-size: 20px">9000</span>
    //           <span>.01</span>
    //         </span>
    //       </div>
    //       <div class="balance-button">提现</div>
    //     </div>
    //     <div class="record">
    //       <div class="">
    //         <p class="record-title">￥600.01</p>
    //         <p class="record-value">昨日到账</p>
    //       </div>
    //       <div>
    //         <p class="record-title">￥9000.01</p>
    //         <p class="record-value">总到账</p>
    //       </div>
    //       <div>
    //         <p class="record-title">￥500.01</p>
    //         <p class="record-value">待到账</p>
    //       </div>
    //     </div>
    //   </div>
    // ) : (
    //   <img class="vGuider-img" src={this.value.desc.enterPic + "?imageView2/1/w/750/h/300"} />
    // );
  }
}
